import * as images from "@/components/images/Images";
import { CasesCardProps } from "@/components/screen/global-components/cases/CasesCard";

const contentStandard = {
  title: "Simplify translations for complex use cases",
  description:
    "We pair your project with a highly trained subject matter expert specialized in document translations for your use case.",
  exploreText: "Explore all use cases",
} as const;

const cardsStandard: CasesCardProps[] = [
  {
    title: "Marketing",
    description:
      "Localize marketing content that resonates across global markets, while preserving brand voice and cultural nuance.",
    linkLabel: "Review",
    link: "/use-cases/marketing",
    imageUrl: images.image_card_1,
  },
  {
    title: "Legal",
    description:
      "Precise and secure certified translations for legal documents ensuring accuracy, and compliance in global legal proceedings.",
    linkLabel: "Review",
    link: "/use-cases/legal",
    imageUrl: images.image_card_2,
  },
  {
    title: "Financial",
    description:
      "Specialized translations for financial reports, statements, and documents that maintain technical integrity, and regulatory precision.",
    linkLabel: "Review",
    link: "/use-cases/financial",
    imageUrl: images.image_card_3,
  },
  {
    title: "Medical",
    description:
      "Provide precise, HIPAA-compliant translations for medical documents, research, and patient communications across healthcare sectors.",
    linkLabel: "Review",
    link: "/use-cases/medical",
    imageUrl: images.image_card_4,
  },
];

const contentCertified = {
  title: "Simplify certified translations",
  description:
    "We’ll pair your project with a highly trained subject matter expert specialized in your use case for the most accurate and context-aware precision across even the most technical and complex projects",
  exploreText: "Explore use cases",
} as const;

const cardsCertified: CasesCardProps[] = [
  {
    title: "Academic",
    description:
      "Translate academic transcripts, diplomas, and records with certified accuracy for university admissions and international education requirements.",
    linkLabel: "Review",
    link: "/use-cases/academic",
    imageUrl: images.simplify_card_1,
  },
  {
    title: "Immigration (USCIS)",
    description:
      "Expert translation, certification, and notarization services for personal documents, meeting strict requirements for USCIS and immigration acceptance.",
    linkLabel: "Review",
    link: "/use-cases/uscis-immigration",
    imageUrl: images.simplify_card_2,
  },
  {
    title: "Legal",
    description:
      "Precise and secure certified translations for legal documents ensuring accuracy, and compliance in global legal proceedings.",
    linkLabel: "Review",
    link: "/use-cases/legal",
    imageUrl: images.image_card_2,
  },
  {
    title: "Financial",
    description:
      "Specialized translations for financial reports, statements, and documents that maintain technical integrity, and regulatory precision.",
    linkLabel: "Review",
    link: "/use-cases/financial",
    imageUrl: images.image_card_3,
  },
];

const contentEnterprise = {
  title: "Simplify professional business translation across use cases",
  description:
    "We’ll pair your official document translation project with a highly trained subject matter expert specialized in your use case.",
  exploreText: "Explore use cases",
} as const;

const cardsEnterprise: CasesCardProps[] = [
  {
    title: "Marketing",
    description:
      "Localize marketing content that resonates across global markets, while preserving brand voice and cultural nuance.",
    linkLabel: "Review",
    link: "/use-cases/marketing",
    imageUrl: images.image_card_1,
  },
  {
    title: "Technical",
    description:
      "Convert technical documents with precision and correct technical terminology and understanding of concepts.",
    linkLabel: "Review",
    link: "/use-cases/technical",
    imageUrl: images.image_Tehnical,
  },
  {
    title: "Legal",
    description:
      "Precise and secure certified translations for legal documents ensuring accuracy, and compliance in global legal proceedings.",
    linkLabel: "Review",
    link: "/use-cases/legal",
    imageUrl: images.image_card_2,
  },
  {
    title: "Financial",
    description:
      "Specialized translations for financial reports, statements, and documents that maintain technical integrity, and regulatory precision.",
    linkLabel: "Review",
    link: "/use-cases/financial",
    imageUrl: images.image_card_3,
  },
];

const contentNotarized = {
  title: "Notarized translation for any use case",
  description:
    "Rest assured that your translated documents will be legally recognized by using our translators qualified for subject matter expertise for specific use cases.",
  exploreText: "Explore use cases",
} as const;

const cardsNotarized: CasesCardProps[] = [
  {
    title: "Academic",
    description:
      "Translate academic transcripts, diplomas, and records with certified accuracy for university admissions and international education requirements.",
    linkLabel: "Review",
    link: "#",
    imageUrl: images.simplify_card_1,
  },
  {
    title: "Immigration (USCIS)",
    description:
      "Expert translation, certification, and notarization services for personal documents, meeting strict requirements for USCIS and immigration acceptance.",
    linkLabel: "Review",
    link: "#",
    imageUrl: images.simplify_card_2,
  },
  {
    title: "Legal",
    description:
      "Precise and secure certified translations for legal documents ensuring accuracy, and compliance in global legal proceedings.",
    linkLabel: "Review",
    link: "#",
    imageUrl: images.image_card_2,
  },
  {
    title: "Financial",
    description:
      "Specialized translations for financial reports, statements, and documents that maintain technical integrity, and regulatory precision.",
    linkLabel: "Review",
    link: "#",
    imageUrl: images.image_card_3,
  },
];

const contentUrgent = {
  title: "Fast translations with translator expertise in your use case",
  description:
    "We pair your urgent translation project with a translator specialized in your use case, so that your crisis communications and disaster response, medical emergency, international business transaction, immigration application, litigation, or other reason for urgency is seamless.",
  exploreText: "Explore use cases",
} as const;

const cardsUrgent: CasesCardProps[] = [
  {
    title: "Academic",
    description:
      "Translate academic transcripts, diplomas, and records with certified accuracy for university admissions and international education requirements.",
    linkLabel: "Review",
    link: "/use-cases/academic",
    imageUrl: images.simplify_card_1,
  },
  {
    title: "Immigration (USCIS)",
    description:
      "Expert translation, certification, and notarization services for personal documents, meeting strict requirements for USCIS and immigration acceptance.",
    linkLabel: "Review",
    link: "/use-cases/uscis-immigration",
    imageUrl: images.simplify_card_2,
  },
  {
    title: "Legal",
    description:
      "Precise and secure certified translations for legal documents ensuring accuracy, and compliance in global legal proceedings.",
    linkLabel: "Review",
    link: "/use-cases/legal",
    imageUrl: images.image_card_2,
  },
  {
    title: "Financial",
    description:
      "Specialized translations for financial reports, statements, and documents that maintain technical integrity, and regulatory precision.",
    linkLabel: "Review",
    link: "/use-cases/financial",
    imageUrl: images.image_card_3,
  },
];

export const servicesUseCasesMap = {
  standard: {
    content: contentStandard,
    cards: cardsStandard,
  },
  certified: {
    content: contentCertified,
    cards: cardsCertified,
  },
  enterprise: {
    content: contentEnterprise,
    cards: cardsEnterprise,
  },
  notarized: {
    content: contentNotarized,
    cards: cardsNotarized,
  },
  urgent: {
    content: contentUrgent,
    cards: cardsUrgent,
  },
};
